import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { Router } from '@angular/router';
import { ResponseParserService } from '../../services/response-parser.service';
import { AppDataService } from '../../services/app-data.service';
import { TEMPLATES } from '../../constants/templates.constants';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';

@Component({
  selector: 'app-agency-list', 
  templateUrl: './agency-list.component.html',
  styleUrl: './agency-list.component.scss'
})
export class AgencyListComponent extends BaseCardSetListComponent implements OnInit {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    //private coreService: CoreService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.agencyList,
      () => API_ENDPOINTS.dashboard.getAgencies,
      false);
  }

  ngOnInit(): void {
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
  }

  actionButton_agenciesGrid_datagrid_new_Clicked(event: any): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.agency.prefix]);
  }

  actionButton_agenciesGrid_datagrid_edit_Clicked(event: any): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.agency.prefix, event.event.data.id]);
  }

  dialogSubmitted(event: any): void {
    // No dialog buttons are implemented in this dashboard
  }
}
